import { ActionType } from 'typesafe-actions';
import * as lotteryInfoActions from './lotteryInfoActions';
import BaseReducer, { baseInitialState} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';


export type LotteryInfoGridAction = ActionType<typeof lotteryInfoActions>;

export interface ILotteryInfoStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: {} };
	readonly queries: { [queryKey: string]: [] };
}

export function lotteryInfoReducer(
	state = baseInitialState as ILotteryInfoStateType,
	action: LotteryInfoGridAction,
) {
	const Reducer = new BaseReducer('lotteryInfoReducer');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}

